import React, { useState, useEffect } from 'react';
import t from '@guestyci/localize/t.macro';
import { Button, Text, Stack } from '@guestyci/arc';

const RESEND_COOLDOWN_SEC = 30;

const ResendCodeButton = ({ onResend, disabled = false }) => {
  const [secondsLeft, setSecondsLeft] = useState(RESEND_COOLDOWN_SEC);

  useEffect(() => {
    if (secondsLeft <= 0) return undefined;

    const timer = setInterval(() => {
      setSecondsLeft(s => (s <= 1 ? 0 : s - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft > 0]);

  const handleClick = () => {
    if (secondsLeft > 0 || disabled) return;

    if (onResend()) {
      setSecondsLeft(RESEND_COOLDOWN_SEC);
    }
  };

  return (
    <Stack direction="row" spacing={1} align="center">
      <Text type="secondary">{t("Didn't receive the code?")}</Text>
      <Button
        type="button"
        variant="plain-primary"
        className="gst-h-auto gst-p-0"
        disabled={secondsLeft > 0 || disabled}
        onClick={handleClick}
      >
        {secondsLeft > 0
          ? t('Resend in {seconds}s', { seconds: secondsLeft })
          : t('Resend')}
      </Button>
    </Stack>
  );
};

export default ResendCodeButton;
